import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getDepthCatalog = state => state.models[name].data;
export const getCurDepth = state => state.models[name].item;